import { render, staticRenderFns } from "./header-form.vue?vue&type=template&id=533f4300&scoped=true&"
import script from "./header-form.vue?vue&type=script&lang=js&"
export * from "./header-form.vue?vue&type=script&lang=js&"
import style0 from "./header-form.vue?vue&type=style&index=0&id=533f4300&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533f4300",
  null
  
)

export default component.exports